/* ============================================================================
   BbLAB theme behaviour — rewritten for real Liquid DOM.
   ----------------------------------------------------------------------------
   Ported interactions from the read-only reference front-end: desktop mega
   menu, the full-screen two-level mobile drawer, product gallery, variant
   select, quantity stepper and the bookmark store. It is a fresh
   implementation over the server-rendered markup; the original renderer is NOT
   shipped. Cart add stays on Shopify's native /cart/add form POST; "buy now"
   uses the native Cart AJAX API (/cart/add.js), keeps the active locale prefix
   and then hands off to that locale's /checkout.
   ============================================================================ */
(function () {
  'use strict';

  var $ = function (selector, scope) { return (scope || document).querySelector(selector); };
  var $$ = function (selector, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(selector)); };

  /* ── toast ─────────────────────────────────────────────────────────────── */
  var toastTimer;
  function toast(message) {
    var el = $('#bblab-toast');
    if (!el) return;
    el.textContent = message;
    el.classList.add('show');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () { el.classList.remove('show'); }, 2600);
  }

  /* ── bookmark store (localStorage, mirrors reference bblab-*-saved-v1) ─── */
  var SAVED_KEY = 'bblab-theme-saved-v1';
  function readSaved() {
    try {
      var data = JSON.parse(window.localStorage.getItem(SAVED_KEY) || '[]');
      return Array.isArray(data) ? data.filter(function (id) { return typeof id === 'string'; }) : [];
    } catch (error) { return []; }
  }
  function updateSavedCount() {
    var count = readSaved().length;
    $$('[data-saved-count]').forEach(function (el) { el.textContent = String(count); });
  }
  function writeSaved(list) {
    try { window.localStorage.setItem(SAVED_KEY, JSON.stringify(list)); } catch (error) { /* ignore */ }
    updateSavedCount();
  }
  function initSaved(root) {
    var saved = readSaved();
    $$('[data-save]', root).forEach(function (button) {
      var on = saved.indexOf(button.dataset.save) !== -1;
      button.classList.toggle('selected', on);
      button.setAttribute('aria-pressed', String(on));
    });
    updateSavedCount();
  }
  function toggleSave(button) {
    var id = button.dataset.save;
    if (!id) return;
    var list = readSaved();
    var index = list.indexOf(id);
    var adding = index === -1;
    if (adding) list.push(id); else list.splice(index, 1);
    writeSaved(list);
    initSaved(document);
    toast(adding ? 'お気に入りに追加しました。' : 'お気に入りから削除しました。');
  }

  /* ── bookmark panel: local handles -> same-origin product.js ───────────── */
  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function safeImageUrl(url) {
    if (typeof url !== 'string' || !url) return '';
    var value = url.indexOf('//') === 0 ? 'https:' + url : url;
    if (/^https:\/\/[a-z0-9.-]+\//i.test(value)) return value;
    if (/^\/[^/\\]/.test(value)) return value;
    return '';
  }
  function savedPanelEls() {
    var panel = $('[data-saved-panel]');
    return { panel: panel, body: panel ? $('[data-saved-body]', panel) : null };
  }
  function renderSavedState(message) {
    var els = savedPanelEls();
    if (!els.body) return;
    els.body.innerHTML = '<p class="saved-panel-state" role="status">' + escapeHtml(message) + '</p>';
  }
  function fetchSavedProduct(handle) {
    var endpoint = '/products/' + encodeURIComponent(handle) + '.js';
    return fetch(endpoint, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error(String(response.status));
        return response.json();
      });
  }
  function loadSavedProducts() {
    var els = savedPanelEls();
    if (!els.body) return;
    var list = readSaved();
    if (!list.length) { renderSavedState('お気に入りはまだありません。'); return; }
    renderSavedState('お気に入りを読み込んでいます…');
    Promise.allSettled(list.map(function (handle) {
      return fetchSavedProduct(handle).then(function (product) { return { handle: handle, product: product }; });
    })).then(function (results) {
      var html = '';
      results.forEach(function (result, index) {
        // Keep the stored handle from the original list on failure. Deriving it
        // from result.value made a rejected fetch yield '', so the error row's
        // delete button was empty and the broken bookmark could never be removed.
        var handle = list[index];
        if (result.status !== 'fulfilled' || !result.value.product) {
          html += '<div class="saved-item saved-item--error"><p>' + escapeHtml(handle || '商品') + ' の情報を取得できませんでした。</p>' +
            '<button type="button" class="text-link" data-saved-remove="' + escapeHtml(handle) + '">削除</button></div>';
          return;
        }
        var product = result.value.product;
        var resolvedHandle = product.handle || handle;
        var image = safeImageUrl(product.featured_image);
        var price = typeof product.price === 'number' ? '¥' + (product.price / 100).toLocaleString('ja-JP') : '';
        html += '<div class="saved-item">' +
          (image
            ? '<a class="saved-item-media" href="/products/' + encodeURIComponent(resolvedHandle) + '"><img src="' + escapeHtml(image) + '" alt="" loading="lazy"></a>'
            : '<span class="saved-item-media" aria-hidden="true"></span>') +
          '<div class="saved-item-copy">' +
          '<a class="saved-item-title" href="/products/' + encodeURIComponent(resolvedHandle) + '">' + escapeHtml(product.title || resolvedHandle) + '</a>' +
          (price ? '<p class="saved-item-price">' + escapeHtml(price) + '</p>' : '') +
          (product.available === false ? '<p class="saved-item-soldout">完売</p>' : '') +
          '</div>' +
          '<button type="button" class="saved-item-remove icon-button" data-saved-remove="' + escapeHtml(resolvedHandle) + '" aria-label="お気に入りから削除">×</button>' +
          '</div>';
      });
      els.body.innerHTML = html;
    }).catch(function () { renderSavedState('お気に入りを読み込めませんでした。'); });
  }
  var savedLastFocus = null;
  function openSavedPanel() {
    var els = savedPanelEls();
    if (!els.panel || !els.panel.hidden) return;
    if (mobNav && !mobNav.hidden) closeMobNav();
    closeSearch();
    if (activeMenu) closeMenu();
    if (typeof window !== 'undefined' && window.__bblabCloseFilterDrawers) window.__bblabCloseFilterDrawers();
    savedLastFocus = document.activeElement;
    els.panel.hidden = false;
    document.body.classList.add('saved-open');
    setBackgroundInert(true);
    var close = $('[data-action="saved-close"]', els.panel);
    if (close) close.focus();
    loadSavedProducts();
  }
  function closeSavedPanel() {
    var els = savedPanelEls();
    if (!els.panel || els.panel.hidden) return;
    els.panel.hidden = true;
    document.body.classList.remove('saved-open');
    setBackgroundInert(false);
    if (savedLastFocus && savedLastFocus.focus) savedLastFocus.focus();
    savedLastFocus = null;
  }
  function trapSavedFocus(event) {
    var panel = savedPanelEls().panel;
    if (!panel || panel.hidden || event.key !== 'Tab') return;
    var focusables = $$('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])', panel)
      .filter(function (node) { return !node.hidden && node.getClientRects().length > 0; });
    if (!focusables.length) return;
    var first = focusables[0], last = focusables[focusables.length - 1];
    if (!panel.contains(document.activeElement) || (!event.shiftKey && document.activeElement === last)) {
      event.preventDefault();
      first.focus();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    }
  }
  function removeSaved(handle) {
    if (!handle) return;
    writeSaved(readSaved().filter(function (id) { return id !== handle; }));
    initSaved();
    loadSavedProducts();
  }

  /* ── desktop mega menu ─────────────────────────────────────────────────── */
  var MOBILE_QUERY = '(max-width: 1050px)';
  // Re-queried on every initHeader() so theme-editor section reloads keep a
  // live reference instead of pointing at a detached node.
  var mega = null;
  var header = null;
  var docBound = false;
  var activeMenu = '';
  var menuTimer;
  // Nav entry that opened the active panel, so Escape can hand focus back.
  var menuTrigger = null;
  // When Escape restores focus to the nav entry, that entry's own `focus`
  // listener would immediately reopen the panel. This one-shot guard swallows
  // exactly that focus event, then clears itself so a later Tab/click still
  // opens the menu normally.
  var suppressFocusOpen = null;

  function desktopButtons() { return $$('.desktop-nav [data-menu]'); }
  function syncDesktopExpanded(id) {
    desktopButtons().forEach(function (button) {
      button.setAttribute('aria-expanded', String(button.dataset.menu === id));
    });
  }
  function setGroup(panel, groupId) {
    if (!panel) return;
    $$('.mega-groups [data-menu-group]', panel).forEach(function (button) {
      var on = button.dataset.menuGroup === groupId;
      button.classList.toggle('active', on);
      button.setAttribute('aria-expanded', String(on));
    });
    // Reference `#mega-options` is the link container itself and swaps its
    // innerHTML per group, so `flex-direction:column` stacks the links. The
    // theme pre-renders all three groups server-side and toggles `hidden` on
    // the direct link children instead, keeping that same direct-child layout.
    $$('.mega-options > a', panel).forEach(function (link) {
      link.hidden = link.dataset.group !== groupId;
    });
  }
  // Reference `menuLine()`: the four product lines render as
  // `.nav-line-row > button + .nav-line-detail` (label / care / description
  // columns); exactly one detail is visible at a time.
  function setLine(panel, lineId) {
    if (!panel) return;
    $$('[data-nav-line]', panel).forEach(function (button) {
      var on = button.dataset.navLine === lineId;
      button.classList.toggle('active', on);
      button.setAttribute('aria-expanded', String(on));
    });
    $$('.nav-line-detail', panel).forEach(function (detail) {
      detail.hidden = detail.dataset.lineDetail !== lineId;
    });
  }
  function selectMenuTarget(button) {
    var panel = button.closest('.mega-panel');
    if (button.dataset.menuGroup) setGroup(panel, button.dataset.menuGroup);
    if (button.dataset.navLine) setLine(panel, button.dataset.navLine);
  }
  // Entering a top-level menu shows only the outer panel. The reference demo
  // starts with the three taxonomy buttons (or the four product lines) and an
  // empty detail column, so the old "auto-select the first group" is gone.
  function clearMenuDetail(panel) {
    if (!panel) return;
    setGroup(panel, '');
    setLine(panel, '');
  }
  // Hovering inside the panel: a group button (or a product-line row) reveals
  // its own detail, while the remaining panel space clears it. The
  // `.mega-content` / `.nav-line-row` keep-zones stop the detail from
  // collapsing while the pointer travels from a trigger into its own options.
  function hoverMenuDetail(event) {
    var panel = event.target.closest('.mega-panel');
    // 2026-10-07: pointer over the mega blank area has no .mega-panel ancestor,
    // so fall back to the open panel (activeMenu) and still clear its detail.
    if (!panel) {
      $$('.mega-panel', mega).forEach(function (item) {
        if (item.dataset.panel === activeMenu) panel = item;
      });
    }
    if (!panel) return;
    if (panel.dataset.kind === 'lines') {
      var row = event.target.closest('.nav-line-row');
      if (row) {
        var lineButton = $('[data-nav-line]', row);
        if (lineButton) setLine(panel, lineButton.dataset.navLine);
        return;
      }
      setLine(panel, '');
      return;
    }
    var groupButton = event.target.closest('[data-menu-group]');
    if (groupButton) { setGroup(panel, groupButton.dataset.menuGroup); return; }
    if (event.target.closest('.mega-content')) return;
    setGroup(panel, '');
  }
  function openMenu(id, trigger) {
    if (!mega) return;
    window.clearTimeout(menuTimer);
    if (activeMenu === id) return;
    if (typeof window !== 'undefined' && window.__bblabCloseFilterDrawers) window.__bblabCloseFilterDrawers();
    activeMenu = id;
    if (trigger) menuTrigger = trigger;
    syncDesktopExpanded(id);
    mega.hidden = false;
    var panel = null;
    $$('.mega-panel', mega).forEach(function (item) {
      var on = item.dataset.panel === id;
      item.hidden = !on;
      if (on) panel = item;
    });
    clearMenuDetail(panel);
    document.body.classList.add('menu-open');
  }
  function closeMenu() {
    window.clearTimeout(menuTimer);
    activeMenu = '';
    if (mega) {
      mega.hidden = true;
      $$('.mega-panel', mega).forEach(function (panel) { panel.hidden = true; });
    }
    syncDesktopExpanded('');
    document.body.classList.remove('menu-open');
  }
  // Escape closes the panel and hands focus back to the nav entry that opened it.
  function closeMenuAndRestoreFocus() {
    var trigger = menuTrigger;
    closeMenu();
    if (trigger && typeof trigger.focus === 'function') {
      suppressFocusOpen = trigger;
      trigger.focus();
      window.setTimeout(function () {
        if (suppressFocusOpen === trigger) suppressFocusOpen = null;
      }, 0);
    }
  }
  function initHeader() {
    mega = $('#mega');
    header = $('#header');
    mobNav = $('#mob-nav');
    if (mega && mega.dataset.bound !== 'true') {
      mega.dataset.bound = 'true';
      desktopButtons().forEach(function (button) {
        var id = button.dataset.menu;
        button.addEventListener('pointerenter', function () { openMenu(id, button); });
        button.addEventListener('focus', function () {
          if (suppressFocusOpen === button) { suppressFocusOpen = null; return; }
          openMenu(id, button);
        });
        button.addEventListener('click', function () {
          // Reference: on hover-capable desktop a click only opens. Toggling it
          // closed made hover-then-click collapse the panel the hover opened.
          if (activeMenu === id && !window.matchMedia('(hover: hover)').matches) closeMenu();
          else openMenu(id, button);
        });
      });
      mega.addEventListener('pointerover', function (event) { hoverMenuDetail(event); });
      mega.addEventListener('focusin', function (event) {
        var button = event.target.closest('[data-menu-group],[data-nav-line]');
        if (button) selectMenuTarget(button);
      });
      mega.addEventListener('click', function (event) {
        if (event.target.closest('[data-action="close-menu"]')) { closeMenu(); return; }
        var button = event.target.closest('[data-menu-group],[data-nav-line]');
        if (button) selectMenuTarget(button);
      });
      if (header) {
        // Reference closes the panel when the pointer moves onto another
        // desktop nav entry or a header action.
        $$('.desktop-nav > a, .header-actions > *').forEach(function (el) {
          el.addEventListener('pointerenter', function (event) {
            if (event.pointerType === 'mouse') closeMenu();
          });
        });
        header.addEventListener('pointerleave', function (event) {
          if (event.pointerType === 'mouse') menuTimer = window.setTimeout(closeMenu, 140);
        });
        header.addEventListener('pointerenter', function () { window.clearTimeout(menuTimer); });
      }
    }
    // Document-level listeners use the live `mega`/`header`/`mobNav` refs, so
    // they are bound once even though initHeader() runs again on section reload.
    if (!docBound) {
      docBound = true;
      document.addEventListener('pointerdown', function (event) {
        if (activeMenu && header && !header.contains(event.target)) closeMenu();
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && activeMenu) closeMenuAndRestoreFocus();
      });
    }
  }
  window.addEventListener('resize', function () {
    if (window.matchMedia(MOBILE_QUERY).matches) closeMenu();
    else closeMobNav();
  });

  /* ── mobile drawer (two levels, focus trap, background inert) ──────────── */
  var mobNav = null;
  var lastFocus = null;

  function setBackgroundInert(on) {
    ['#header', '#MainContent', 'footer'].forEach(function (selector) {
      var node = $(selector);
      if (!node) return;
      if (on) node.setAttribute('inert', ''); else node.removeAttribute('inert');
    });
  }
  // The search dialog sits inside #header, so the drawer helper (which inerts
  // #header wholesale) cannot be reused. Inert the header's other children plus
  // main/footer, leaving the open dialog operable for keyboard and AT.
  function setSearchBackgroundInert(on) {
    var header = $('#header');
    if (header && header.children) {
      Array.prototype.slice.call(header.children).forEach(function (child) {
        if (child.id === 'header-search') return;
        if (on) child.setAttribute('inert', ''); else child.removeAttribute('inert');
      });
    }
    ['#MainContent', 'footer'].forEach(function (selector) {
      var node = $(selector);
      if (!node) return;
      if (on) node.setAttribute('inert', ''); else node.removeAttribute('inert');
    });
  }
  function mobNavDepth(depth, id) {
    if (!mobNav) return;
    var focusTarget = null;
    if (depth === 2 && id) {
      mobNav.dataset.returnSub = id;
      $$('.mob-sub-panel', mobNav).forEach(function (panel) {
        panel.hidden = panel.dataset.mobPanel !== id;
      });
      var title = $('[data-mob-title]', mobNav);
      var trigger = $('[data-mob-sub="' + id + '"] span', mobNav);
      if (title) title.textContent = trigger ? trigger.textContent.trim() : '';
      mobNav.scrollTop = 0;
      focusTarget = $('.mob-nav-back', mobNav);
    }
    if (depth === 1) {
      $$('.mob-sub-panel', mobNav).forEach(function (panel) { panel.hidden = true; });
      focusTarget = $('[data-mob-sub="' + mobNav.dataset.returnSub + '"]', mobNav) || $('.mob-nav-close', mobNav);
    }
    mobNav.dataset.depth = String(depth);
    if (!mobNav.hidden && focusTarget) focusTarget.focus();
  }
  function openMobNav() {
    if (!mobNav || !mobNav.hidden) return;
    closeSavedPanel();
    lastFocus = document.activeElement;
    mobNavDepth(1);
    mobNav.hidden = false;
    $$('.mobile-menu').forEach(function (button) { button.setAttribute('aria-expanded', 'true'); });
    setBackgroundInert(true);
    document.body.classList.add('mob-nav-open');
    var close = $('.mob-nav-close', mobNav);
    if (close) close.focus();
  }
  function closeMobNav() {
    if (!mobNav) return;
    var wasOpen = !mobNav.hidden;
    mobNav.hidden = true;
    $$('.mobile-menu').forEach(function (button) { button.setAttribute('aria-expanded', 'false'); });
    if (wasOpen) setBackgroundInert(false);
    document.body.classList.remove('mob-nav-open');
    if (wasOpen && lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ── header search overlay (V2 nav/states/04-search) ───────────────────── */
  // The overlay is progressive enhancement over the trigger's real /search
  // href; the form itself is a native GET form and its recommendation cards are
  // server-rendered real products. Nothing is matched or fetched client-side.
  var searchLastFocus = null;
  function searchEl() { return $('#header-search'); }
  function setSearchExpanded(on) {
    $$('[data-action="search-open"]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', String(on));
    });
  }
  function openSearch() {
    var overlay = searchEl();
    if (!overlay || !overlay.hidden) return;
    closeSavedPanel();
    if (mobNav && !mobNav.hidden) closeMobNav();
    if (activeMenu) closeMenu();
    if (typeof window !== 'undefined' && window.__bblabCloseFilterDrawers) window.__bblabCloseFilterDrawers();
    searchLastFocus = document.activeElement;
    overlay.hidden = false;
    document.body.classList.add('search-open');
    setSearchBackgroundInert(true);
    setSearchExpanded(true);
    var input = $('input[type="search"]', overlay);
    if (input) input.focus();
  }
  function closeSearch() {
    var overlay = searchEl();
    if (!overlay || overlay.hidden) return;
    overlay.hidden = true;
    document.body.classList.remove('search-open');
    setSearchBackgroundInert(false);
    setSearchExpanded(false);
    if (searchLastFocus && searchLastFocus.focus) searchLastFocus.focus();
    searchLastFocus = null;
  }
  // Drawer coordination: the shared filter drawer calls this before it opens,
  // and each header overlay closes the drawer before it opens.
  window.__bblabCloseOverlays = function () {
    if (typeof closeMobNav === 'function') closeMobNav();
    if (typeof closeMenu === 'function') closeMenu();
    if (typeof closeSearch === 'function') closeSearch();
    if (typeof closeSavedPanel === 'function') closeSavedPanel();
  };
  function trapSearchFocus(event) {
    var overlay = searchEl();
    if (!overlay || overlay.hidden || event.key !== 'Tab') return;
    var focusables = $$('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])', overlay)
      .filter(function (node) { return !node.hidden && node.getClientRects().length > 0; });
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
  function initSearch() {
    var overlay = searchEl();
    if (!overlay || overlay.dataset.bound === 'true') return;
    overlay.dataset.bound = 'true';
    overlay.addEventListener('pointerdown', function (event) {
      if (event.target === overlay) closeSearch();
    });
  }

  // Clear every transient open state after the theme editor reloads a section.
  // The reload replaces the header/drawer DOM: a stale activeMenu made the first
  // click on the same nav item a no-op, and a drawer left open kept `inert` on
  // MainContent/footer so the rest of the page stayed unclickable.
  function resetHeaderState() {
    window.clearTimeout(menuTimer);
    activeMenu = '';
    menuTrigger = null;
    if (mega) {
      mega.hidden = true;
      $$('.mega-panel', mega).forEach(function (panel) { panel.hidden = true; });
      // The reloaded markup resets server-side, but clear any transient
      // shop-group / product-line selection left on the old DOM too.
      $$('.mega-options > a', mega).forEach(function (link) { link.hidden = true; });
      $$('.nav-line-detail', mega).forEach(function (detail) { detail.hidden = true; });
    }
    syncDesktopExpanded('');
    if (mobNav) {
      mobNav.hidden = true;
      mobNav.dataset.depth = '1';
      $$('.mob-sub-panel', mobNav).forEach(function (panel) { panel.hidden = true; });
    }
    $$('.mobile-menu').forEach(function (button) { button.setAttribute('aria-expanded', 'false'); });
    setBackgroundInert(false);
    setSearchBackgroundInert(false);
    document.body.classList.remove('menu-open');
    document.body.classList.remove('mob-nav-open');
    var overlay = searchEl();
    if (overlay) overlay.hidden = true;
    document.body.classList.remove('search-open');
    setSearchExpanded(false);
    searchLastFocus = null;
    lastFocus = null;
    var saved = savedPanelEls().panel;
    if (saved) saved.hidden = true;
    document.body.classList.remove('saved-open');
    savedLastFocus = null;
  }

  function trapMobileFocus(event) {
    if (!mobNav || mobNav.hidden || event.key !== 'Tab') return;
    var focusables = $$('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])', mobNav)
      .filter(function (node) { return !node.hidden && node.getClientRects().length > 0; });
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
  document.addEventListener('keydown', function (event) {
    var savedEls = savedPanelEls();
    if (event.key === 'Escape' && savedEls.panel && !savedEls.panel.hidden) { closeSavedPanel(); return; }
    if (savedEls.panel && !savedEls.panel.hidden) { trapSavedFocus(event); return; }
    if (event.key === 'Escape' && searchEl() && !searchEl().hidden) { closeSearch(); return; }
    if (mobNav && !mobNav.hidden && event.key === 'Escape') { closeMobNav(); return; }
    if (mobNav && !mobNav.hidden) { trapMobileFocus(event); return; }
    trapSearchFocus(event);
  });
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-action="menu"]')) { openMobNav(); return; }
    if (event.target.closest('[data-action="mob-close"]')) { closeMobNav(); return; }
    if (event.target.closest('[data-action="mob-back"]')) { mobNavDepth(1); return; }
    if (event.target.closest('[data-action="search-open"]')) { event.preventDefault(); openSearch(); return; }
    if (event.target.closest('[data-action="search-close"]')) { closeSearch(); return; }
    // Shop panel: one taxonomy group open at a time (reference mobGroup()).
    var mobGroup = event.target.closest('[data-mob-group]');
    if (mobGroup) {
      var groupPanel = mobGroup.closest('.mob-sub-panel');
      var groupId = mobGroup.dataset.mobGroup;
      if (groupPanel) {
        $$('.mob-sub-heading', groupPanel).forEach(function (button) {
          button.setAttribute('aria-expanded', String(button.dataset.mobGroup === groupId));
        });
        $$('.mob-sub-list', groupPanel).forEach(function (list) {
          list.hidden = list.id !== ('mob-group-' + groupId);
        });
      }
      return;
    }
    var sub = event.target.closest('[data-mob-sub]');
    if (sub) { mobNavDepth(2, sub.dataset.mobSub); return; }
    if (event.target.closest('[data-action="saved"]')) {
      openSavedPanel();
      return;
    }
    if (event.target.closest('[data-action="saved-close"]')) {
      closeSavedPanel();
      return;
    }
    if (event.target.matches('[data-saved-panel]')) {
      closeSavedPanel();
      return;
    }
    var savedRemove = event.target.closest('[data-saved-remove]');
    if (savedRemove) {
      removeSaved(savedRemove.dataset.savedRemove);
      return;
    }
    if (event.target.closest('[data-action="social"]')) {
      toast('正式なブランドアカウントの URL は確認待ちです。');
      return;
    }
    // Cart: the +/- stepper adjusts the real updates[] input and hands the
    // native form back to Shopify. One native /cart submit owns a shared lock,
    // so a second stepper or removal cannot change the serialised body while
    // the first request is in flight. No client-side totals.
    var cartChange = event.target.closest('[data-cart-change]');
    if (cartChange) {
      cartStepper(cartChange);
      return;
    }
    var cartRemove = event.target.closest('.remove');
    if (cartRemove && cartRemove.closest('.cart-page')) {
      var removeForm = cartRemove.closest('form');
      if (removeForm && removeForm.__bblabCartBusy) {
        event.preventDefault();
        return;
      }
      return;
    }
    var railButton = event.target.closest('[data-action="rail-prev"], [data-action="rail-next"]');
    if (railButton) { moveRail(railButton); return; }
    var save = event.target.closest('[data-save]');
    if (save) toggleSave(save);
  });

  // Native collection sort: the select is a real GET form field, so submitting
  // the form is a genuine Shopify sort request.
  document.addEventListener('change', function (event) {
    var sort = event.target.closest('[data-action="collection-sort"]');
    if (sort && sort.form) sort.form.submit();
  });

  // Offline fixture guard: a POST/checkout must stay inside the local fixture
  // and never reach Shopify. Real stores do not set data-fixture-page.
  document.addEventListener('submit', function (event) {
    if (!document.body.hasAttribute('data-fixture-page')) return;
    var form = event.target;
    var action = (form.getAttribute('action') || '');
    if (/^\/(cart|contact)/.test(action) || (form.hasAttribute('data-mock') && !/^\/(collections|search)/.test(action))) {
      event.preventDefault();
      toast('ローカルfixtureです。実際の送信・購入は行われません。');
    }
  }, true);

  /* ── native cart: quantity rules + one shared native submit lock ───────── */
  // The cart form is a real Shopify /cart POST. The front end only validates
  // the client value and manages one in-flight lock; the backend remains the
  // authority for stock and price, so a page rule is never treated as live
  // inventory. 0 always removes the line, even when the positive rule has a
  // higher min, and the default rule (min 1, no max, increment 1) is exactly
  // that: unlimited, never a 99 ceiling.
  var CART_DEFAULT_MIN = 1;
  var CART_DEFAULT_INCREMENT = 1;
  var CART_BUSY_MESSAGE = 'カートを更新しています…';

  function cartLineOf(el) {
    return el && el.closest ? el.closest('[data-cart-line]') : null;
  }
  function cartQuantityInput(row) {
    return row ? row.querySelector('input[name="updates[]"]') : null;
  }
  function cartLineRule(input) {
    var min = Math.floor(attrQuantity(input, 'cartMin', CART_DEFAULT_MIN));
    var increment = Math.floor(attrQuantity(input, 'cartIncrement', CART_DEFAULT_INCREMENT));
    var max = attrQuantity(input, 'cartMax', null);
    if (max !== null && max !== undefined) max = Math.floor(max);
    if (!isFinite(min) || min < 0) min = CART_DEFAULT_MIN;
    if (!isFinite(increment) || increment < 1) increment = CART_DEFAULT_INCREMENT;
    if (max !== null && (!isFinite(max) || max < min)) max = null;
    return { min: min, max: max, increment: increment };
  }
  // Strict non-negative safe integer. `0` is the removal value; everything
  // else (empty, negative, fractional, non-numeric, scientific, unsafe) is
  // rejected instead of being coerced.
  function parseCartQuantityValue(input) {
    var text = input && input.value !== undefined && input.value !== null ? String(input.value).trim() : '';
    if (!/^[0-9]+$/.test(text)) return { state: 'invalid' };
    var value = Number(text);
    if (!isFinite(value) || Math.floor(value) !== value || value > Number.MAX_SAFE_INTEGER) return { state: 'invalid' };
    if (value === 0) return { state: 'remove', value: 0 };
    return { state: 'positive', value: value };
  }
  function cartQuantityMessage(rule) {
    if (rule.max === null) {
      if (rule.increment > 1) return '数量は' + rule.min + '以上の整数を' + rule.increment + '個単位でご指定ください。';
      return '数量は' + rule.min + '以上の整数でご指定ください。';
    }
    if (rule.increment > 1) return '数量は' + rule.min + '〜' + rule.max + 'の範囲で、' + rule.increment + '個単位でご指定ください。';
    return '数量は' + rule.min + '〜' + rule.max + 'の整数でご指定ください。';
  }
  function cartQuantityError(input) {
    var rule = cartLineRule(input);
    var parsed = parseCartQuantityValue(input);
    if (parsed.state === 'invalid') return cartQuantityMessage(rule);
    if (parsed.state === 'remove') return '';
    if (parsed.value < rule.min) return cartQuantityMessage(rule);
    if (rule.max !== null && parsed.value > rule.max) return cartQuantityMessage(rule);
    if ((parsed.value - rule.min) % rule.increment !== 0) return cartQuantityMessage(rule);
    return '';
  }
  // The client status/aria/customValidity live next to the server error node;
  // editing a row clears only the client state and restores the input.
  function setCartInputError(input, message) {
    if (!input) return;
    var row = cartLineOf(input);
    var status = row ? row.querySelector('[data-cart-status]') : null;
    if (status) { status.textContent = message || ''; status.hidden = !message; }
    if (message) input.setAttribute('aria-invalid', 'true');
    else input.removeAttribute('aria-invalid');
    if (typeof input.setCustomValidity === 'function') input.setCustomValidity(message || '');
  }
  function cartFormValid(form) {
    var valid = true;
    $$('input[name="updates[]"]', form).forEach(function (input) {
      var message = cartQuantityError(input);
      if (message) valid = false;
      setCartInputError(input, message);
    });
    return valid;
  }
  // Only the exact attributes the lock changes are captured and restored:
  // unnamed steppers' `disabled` and the named quantity inputs' `readOnly`.
  // `input.disabled` is never written here, so a state owned by another script
  // survives a release untouched.
  function cartLockEntries(form) {
    var entries = [];
    $$('[data-cart-change]', form).forEach(function (button) {
      entries.push({ el: button, prop: 'disabled', value: !!button.disabled });
    });
    $$('input[name="updates[]"]', form).forEach(function (input) {
      if ('readOnly' in input) entries.push({ el: input, prop: 'readOnly', value: !!input.readOnly });
    });
    return entries;
  }
  // Only unnamed controls are disabled; the named updates[] values and the
  // named update/checkout submit buttons stay serialisable for the first
  // native FormData, so Shopify still receives every line and the action name.
  function applyCartLock(form) {
    $$('[data-cart-change]', form).forEach(function (button) { button.disabled = true; });
    $$('input[name="updates[]"]', form).forEach(function (input) {
      if ('readOnly' in input) input.readOnly = true;
    });
    form.setAttribute('aria-busy', 'true');
    var status = $('[data-cart-busy]', form);
    if (status) { status.textContent = CART_BUSY_MESSAGE; status.hidden = false; }
  }
  function holdCartLock(form) {
    if (!form || form.__bblabCartBusy) return;
    form.__bblabCartBusy = true;
    form.__bblabCartLeft = false;
    form.__bblabCartPrev = cartLockEntries(form);
    applyCartLock(form);
  }
  function releaseCartBusy(form) {
    if (!form) return;
    form.__bblabCartBusy = false;
    form.__bblabCartLeft = false;
    (form.__bblabCartPrev || []).forEach(function (entry) {
      entry.el[entry.prop] = entry.value;
    });
    form.__bblabCartPrev = null;
    form.removeAttribute('aria-busy');
    var status = $('[data-cart-busy]', form);
    if (status) { status.textContent = ''; status.hidden = true; }
  }
  // Keep the `update` named-submit semantics: requestSubmit(updateButton) runs
  // interactive validation and the submit listeners. Without requestSubmit the
  // native update button click is the only fallback; form.submit() would skip
  // validation and every listener, so it is never used here.
  function submitCartUpdate(form) {
    if (!form) return false;
    var updateButton = $('button[name="update"]', form) || $('button[type="submit"]', form);
    if (typeof form.requestSubmit === 'function') {
      if (updateButton) form.requestSubmit(updateButton);
      else form.requestSubmit();
      return true;
    }
    if (updateButton && typeof updateButton.click === 'function') {
      updateButton.click();
      return true;
    }
    return false;
  }
  function cartStepper(button) {
    var row = cartLineOf(button);
    var input = cartQuantityInput(row);
    var form = button.closest('form');
    if (!input || !form || form.__bblabCartBusy) return;
    var rule = cartLineRule(input);
    var direction = Number(button.dataset.cartChange) || 0;
    if (!direction) return;
    // Gate on the same validator the submit path uses. Every illegal value
    // (below min, over max, off increment, empty, non-numeric, unsafe) keeps
    // its text, shows the row's Japanese rule and never submits; the stepper
    // must not silently correct the value or turn an illegal one into a delete.
    var error = cartQuantityError(input);
    if (error) { setCartInputError(input, error); return; }
    var parsed = parseCartQuantityValue(input);
    var next;
    if (direction > 0) {
      if (parsed.state === 'remove') next = rule.min;
      else {
        next = parsed.value + rule.increment;
        // At (or past) the real max the stepper does not silently submit.
        if (rule.max !== null && next > rule.max) return;
      }
      if (next > Number.MAX_SAFE_INTEGER) return;
    } else {
      if (parsed.state === 'remove') return;
      next = parsed.value === rule.min ? 0 : parsed.value - rule.increment;
      if (next < 0) next = 0;
    }
    input.value = String(next);
    setCartInputError(input, '');
    submitCartUpdate(form);
  }
  function bindCartForm(form) {
    if (!form || form.dataset.cartSubmitBound === 'true') return;
    form.dataset.cartSubmitBound = 'true';
    form.addEventListener('submit', function (event) {
      if (isFixturePage()) {
        if (!event.defaultPrevented) {
          event.preventDefault();
          toast('ローカルfixtureです。実際の更新・購入は行われません。');
        }
        return;
      }
      // A listener that already cancelled the POST means nothing left the page,
      // so the shared lock must never be taken.
      if (event.defaultPrevented) return;
      if (form.__bblabCartBusy) { event.preventDefault(); return; }
      if (!cartFormValid(form)) { event.preventDefault(); return; }
      holdCartLock(form);
      var token = (form.__bblabCartToken || 0) + 1;
      form.__bblabCartToken = token;
      // A browser may run a microtask checkpoint after every listener, so a
      // microtask queued here can run before a later listener calls
      // preventDefault and miss the cancel. The zero-delay task is
      // authoritative: it runs after the whole submit dispatch, when
      // `defaultPrevented` is final. A POST that proceeds keeps the lock.
      function confirmCartCancelled() {
        if (form.__bblabCartToken !== token || !form.__bblabCartBusy) return;
        if (event.defaultPrevented) releaseCartBusy(form);
      }
      Promise.resolve().then(confirmCartCancelled);
      if (typeof window.setTimeout === 'function') {
        window.setTimeout(confirmCartCancelled, 0);
      }
    });
    $$('input[name="updates[]"]', form).forEach(function (input) {
      if (input.dataset.cartInputBound === 'true') return;
      input.dataset.cartInputBound = 'true';
      input.addEventListener('input', function () {
        // The unknown/real request owns the row while busy; editing must not
        // clear the lock or its status.
        if (form.__bblabCartBusy) return;
        setCartInputError(input, '');
      });
    });
  }
  function initCart(root) {
    $$('#bblab-cart-form', root || document).forEach(bindCartForm);
  }
  // A native /cart POST really hands the document off, so `pagehide` records
  // that hand-off and only a persisted `pageshow` after it unlocks the cart. A
  // synthetic pageshow or a section reload leaves the in-flight lock alone.
  function markNativeCartLeft() {
    $$('#bblab-cart-form', document).forEach(function (form) {
      if (form.__bblabCartBusy) form.__bblabCartLeft = true;
    });
  }
  function restoreCartLocks(root, persisted) {
    $$('#bblab-cart-form', root || document).forEach(function (form) {
      if (!form.__bblabCartBusy) return;
      if (persisted && form.__bblabCartLeft) { releaseCartBusy(form); return; }
      applyCartLock(form);
    });
  }

  /* ── legacy / unsupported filter query notice ──────────────────────────── */
  // The old SPA filtered with `?category=` / `?concern=` / `?series=`. Shopify
  // ignores those unknown parameters, so an old bookmark could silently show an
  // unfiltered grid; the legacy notice covers those keys.
  //
  // The separate "unsupported" notice may only fire when a native `filter.*`
  // parameter is absent from the controls the current surface actually renders.
  // Batch 3 replaced the old `.collection-filters` form with the shared
  // `[data-filter-form]` drawer, so read the drawer's real checkbox/number
  // controls first and keep the legacy form as a fallback. An empty price
  // parameter is not a filter (the blank number input simply re-submitted) and
  // `0` is a real value, so a present `value` is required to flag anything.
  function initCollectionNotice(root) {
    var section = (root && root.querySelector && root.querySelector('[data-bblab-collection]')) || $('[data-bblab-collection]');
    if (!section) return;
    var notice = $('[data-legacy-filter-notice]', section);
    var params = new URLSearchParams(window.location.search);
    var legacy = ['category', 'concern', 'series'].some(function (key) { return params.getAll(key).length > 0; });
    if (notice) notice.hidden = !legacy;
    var unsupportedNotice = $('[data-unsupported-filter-notice]', section);
    if (unsupportedNotice) {
      var supported = $$('[data-filter-form] input[name], .collection-filters input[name]', section)
        .filter(function (input) {
          var type = (input.getAttribute && input.getAttribute('type')) || input.type || '';
          return type === 'checkbox' || type === 'number';
        })
        .map(function (input) { return input.name; });
      var unsupported = false;
      params.forEach(function (value, key) {
        if (key.indexOf('filter.') === 0 && value && supported.indexOf(key) === -1) unsupported = true;
      });
      unsupportedNotice.hidden = !unsupported;
    }
  }

  /* ── product gallery ───────────────────────────────────────────────────── */
  function clampIndex(value, total) {
    return Math.max(0, Math.min(total - 1, value));
  }
  // An explicit media binding only matches this gallery's own native
  // featured_media / featured_image id, or the identical explicit image URL.
  // The query string is ignored so a rendered `?v=…&width=…` rendition still
  // equals the variant's featured src; nothing is matched by slot order or name.
  function normalizeMediaUrl(url) {
    if (typeof url !== 'string' || !url) return '';
    var value = url.trim();
    var cut = value.search(/[?#]/);
    if (cut !== -1) value = value.slice(0, cut);
    // Mirror the Liquid normaliser so both ends agree on the same image when one
    // side is rendered absolute (https://host/...) and the other protocol-
    // relative (//host/...). Only the path may identify an image: never the file
    // name or a rendition/capacity size.
    value = value.replace(/^https?:\/\//i, '');
    value = value.replace(/^\/\//, '');
    return value;
  }
  function mediaMatchesOption(slide, option) {
    if (!slide || !option) return false;
    var mediaId = option.dataset.featuredMediaId;
    if (mediaId && slide.dataset.mediaId && String(mediaId) === String(slide.dataset.mediaId)) return true;
    var imageId = option.dataset.featuredImageId;
    if (imageId && slide.dataset.imageId && String(imageId) === String(slide.dataset.imageId)) return true;
    var src = option.dataset.featuredSrc;
    if (src && slide.dataset.mediaSrc && normalizeMediaUrl(src) === normalizeMediaUrl(slide.dataset.mediaSrc)) return true;
    return false;
  }
  // V2 two-panel gallery: the left hero panel shows the active image, the right
  // hero panel shows the next real image (wraps). Both arrow pairs step the same
  // index; the left pagination selects directly; the right progress bar mirrors
  // the paired image. All slides are server-rendered from real product media.
  // The local API is attached to the gallery element so the variant handler can
  // move the shared index without adding a second global framework.
  function bindGallery(root) {
    var gallery = $('[data-gallery]', root || document);
    if (!gallery) return null;
    if (gallery.__bblabGallery) return gallery.__bblabGallery;
    gallery.dataset.galleryBound = 'true';
    var slides = $$('[data-gallery-image]', gallery);
    var total = Number(gallery.dataset.galleryTotal) || 0;
    if (!total || total < 1) total = 1;
    var api = {
      total: total,
      indexOfOption: function (option) {
        if (!option) return -1;
        for (var i = 0; i < slides.length; i += 1) {
          if (mediaMatchesOption(slides[i], option)) return Number(slides[i].dataset.gallerySlot);
        }
        return -1;
      },
      setIndex: function () {},
      index: function () { return 0; },
    };
    gallery.__bblabGallery = api;
    if (!slides.length || total < 2) return api;
    var dots = $$('[data-gallery-index]', gallery);
    var prev = $$('[data-gallery-step="-1"]', gallery);
    var next = $$('[data-gallery-step="1"]', gallery);
    var progress = $$('[data-gallery-progress]', gallery);
    var count = $('[data-gallery-count]', gallery);
    // The server already picked the explicitly bound slot (or 0), so JS starts
    // there instead of jumping a deep link back to the first image.
    var serverSlot = Number(gallery.dataset.galleryInitialSlot);
    var index = isFinite(serverSlot) ? clampIndex(serverSlot, total) : 0;
    function shownFor(panel) {
      if (panel === 'right') return (index + 1) % total;
      return index;
    }
    function render() {
      slides.forEach(function (slide) {
        var panel = slide.dataset.galleryPanel || 'left';
        var on = Number(slide.dataset.gallerySlot) === shownFor(panel);
        slide.classList.toggle('active', on);
        slide.hidden = !on;
      });
      dots.forEach(function (dot) {
        var on = Number(dot.dataset.galleryIndex) === index;
        dot.classList.toggle('active', on);
        dot.setAttribute('aria-selected', String(on));
        dot.tabIndex = on ? 0 : -1;
      });
      prev.forEach(function (button) { button.disabled = index <= 0; });
      next.forEach(function (button) { button.disabled = index >= total - 1; });
      progress.forEach(function (bar) {
        var showRight = !!bar.closest('.hero-panel--buy');
        var shown = shownFor(showRight ? 'right' : 'left');
        var fill = $('span', bar);
        if (fill) fill.style.transform = 'scaleX(' + ((shown + 1) / total) + ')';
      });
      if (count) count.textContent = (index + 1) + ' / ' + total;
    }
    function go(step) { index = clampIndex(index + step, total); render(); }
    prev.forEach(function (button) { button.addEventListener('click', function () { go(-1); }); });
    next.forEach(function (button) { button.addEventListener('click', function () { go(1); }); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        index = clampIndex(Number(dot.dataset.galleryIndex), total);
        render();
      });
    });
    gallery.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      // The purchase form lives inside the same gallery root, so arrow keys must
      // never hijack the number input, the variant <select> or any editable text.
      var target = event.target;
      if (target && target.closest && target.closest('input, textarea, select, [contenteditable=""], [contenteditable="true"]')) return;
      event.preventDefault();
      go(event.key === 'ArrowRight' ? 1 : -1);
      if (target && target.closest('[data-gallery-index]') && dots[index]) dots[index].focus();
    });
    api.setIndex = function (value) {
      index = clampIndex(Number(value), total);
      render();
    };
    api.index = function () { return index; };
    // 2026-10-10 mobile PDP: the two side-by-side panels collapse to one image
    // container and gain a horizontal swipe. Bound to the media panel only, so a
    // swipe on the purchase form/variant select never pages the gallery.
    var mediaPanel = $('.hero-panel--media', gallery) || gallery;
    var touchStartX = null;
    var touchStartY = null;
    mediaPanel.addEventListener('touchstart', function (event) {
      if (!event.changedTouches || event.changedTouches.length !== 1) return;
      touchStartX = event.changedTouches[0].clientX;
      touchStartY = event.changedTouches[0].clientY;
    }, { passive: true });
    mediaPanel.addEventListener('touchend', function (event) {
      if (touchStartX === null || !event.changedTouches || event.changedTouches.length !== 1) return;
      var dx = event.changedTouches[0].clientX - touchStartX;
      var dy = event.changedTouches[0].clientY - touchStartY;
      touchStartX = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      go(dx < 0 ? 1 : -1);
    }, { passive: true });
    render();
    return api;
  }
  // Only an exact binding moves the shared gallery; a missing or unmatched
  // variant keeps the current image. Nothing is appended or guessed.
  function syncGalleryMedia(scope, option) {
    var gallery = $('[data-gallery]', scope || document);
    if (!gallery || !gallery.__bblabGallery) return;
    var matched = gallery.__bblabGallery.indexOfOption(option);
    if (matched >= 0) gallery.__bblabGallery.setIndex(matched);
  }

  /* ── bestsellers rail ──────────────────────────────────────────────────── */
  // Ported from the reference `updateRail` / `railView`: the page number and the
  // first/last disabled state come from real scroll geometry, and every manual
  // scroll or resize re-syncs them. Empty rails hide the whole control group.
  function railView(scrollLeft, clientWidth, scrollWidth) {
    var width = clientWidth > 0 ? clientWidth : 0;
    var scroll = Math.max(0, Number(scrollLeft) || 0);
    var content = Math.max(0, Number(scrollWidth) || 0);
    if (!width) return { page: 0, total: 1, prevDisabled: true, nextDisabled: true };
    var maxScroll = Math.max(0, content - width);
    var total = Math.max(1, Math.ceil(content / width));
    var page = Math.round(scroll / width);
    if (scroll >= maxScroll - 1) page = total - 1;
    page = Math.min(Math.max(page, 0), total - 1);
    return {
      page: page,
      total: total,
      prevDisabled: scroll <= 1,
      nextDisabled: scroll >= maxScroll - 1,
    };
  }
  function updateRail(section) {
    var rail = $('.product-rail', section);
    if (!rail) return;
    var controls = $('.rail-controls', section);
    var count = $('[data-rail-count]', section);
    var prev = $('[data-action="rail-prev"]', section);
    var next = $('[data-action="rail-next"]', section);
    if (!$$('.product-card', rail).length) {
      if (controls) controls.hidden = true;
      if (count) count.textContent = '';
      if (prev) prev.disabled = true;
      if (next) next.disabled = true;
      return;
    }
    if (controls) controls.hidden = false;
    var view = railView(rail.scrollLeft, rail.clientWidth, rail.scrollWidth);
    if (count) count.textContent = (view.page + 1) + ' / ' + view.total;
    if (prev) prev.disabled = view.prevDisabled;
    if (next) next.disabled = view.nextDisabled;
  }
  function initRails(root) {
    $$('.bestsellers', root || document).forEach(function (section) {
      if (section.dataset.railBound !== 'true') {
        section.dataset.railBound = 'true';
        var rail = $('.product-rail', section);
        if (!rail) return;
        rail.addEventListener('scroll', function () { updateRail(section); }, { passive: true });
        window.addEventListener('resize', function () { updateRail(section); });
      }
      updateRail(section);
      window.requestAnimationFrame(function () { updateRail(section); });
    });
  }
  function moveRail(button) {
    var section = button.closest('.bestsellers') || document;
    var rail = $('.product-rail', section);
    if (!rail || !$$('.product-card', rail).length) return;
    var step = rail.clientWidth || rail.getBoundingClientRect().width;
    var direction = button.dataset.action === 'rail-next' ? 1 : -1;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    rail.scrollBy({ left: step * direction, behavior: reduce ? 'auto' : 'smooth' });
  }

  /* ── product form: variant, quantity, buy now ──────────────────────────── */
  // Locale-aware roots. `window.routes` is rendered by the theme layout from
  // Shopify's route objects; `Shopify.routes.root` is Shopify's own localized
  // root. Both keep a language/market prefix like /ja so the Ajax add and the
  // checkout hand-off never fall back to the default locale.
  function cartRoot() {
    var routes = window.routes || {};
    var probes = [routes.cart_add_url, routes.cart_url];
    for (var i = 0; i < probes.length; i++) {
      if (typeof probes[i] !== 'string') continue;
      var cut = probes[i].indexOf('/cart');
      if (cut !== -1) return probes[i].slice(0, cut);
    }
    var shopify = window.Shopify;
    var root = shopify && shopify.routes && shopify.routes.root;
    if (typeof root === 'string' && root) return root.replace(/\/+$/, '');
    return '';
  }
  function cartAddPath() {
    var add = window.routes && window.routes.cart_add_url;
    if (typeof add === 'string' && add) return add.indexOf('.js') === -1 ? add + '.js' : add;
    return cartRoot() + '/cart/add.js';
  }
  function checkoutPath() {
    return cartRoot() + '/checkout';
  }

  // A timed-out or dropped POST has an unknown outcome, so it is never retried
  // automatically. The timeout is generous enough for a real cart write, and it
  // is a real deadline: without an AbortController the attempt still has to end.
  var BUY_TIMEOUT_MS = 12000;
  var BUY_DEFAULT_MIN = 1;
  var BUY_DEFAULT_INCREMENT = 1;
  var BUY_UNKNOWN_MESSAGE = '通信状況により、カートに追加できたか確認できませんでした。カートを開いて内容をご確認ください。';
  // Shopify's Cart AJAX API can first add the largest available quantity and
  // then answer 422, so neither 422 nor a 5xx proves the cart stayed unchanged.
  // Those outcomes stay locked and point at the cart for verification.
  var BUY_PARTIAL_MESSAGE = '在庫またはご指定数量の都合により、ご注文の一部または全部をカートに追加できませんでした。カートを開いて内容をご確認ください。';
  var BUY_SERVER_MESSAGE = 'サーバーでエラーが発生し、カートに追加できたか確認できませんでした。カートを開いて内容をご確認ください。';
  var BUY_THROTTLE_MESSAGE = 'アクセスが集中しています。しばらくしてからもう一度お試しください。';
  var BUY_REJECTED_MESSAGE = 'ご注文をカートに追加できませんでした。入力内容をご確認のうえ、もう一度お試しください。';
  var BUY_SOLD_OUT_MESSAGE = 'ただいま品切れのため、カートに追加できません。';
  var BUY_MISSING_ID_MESSAGE = '商品を特定できませんでした。ページを再読み込みしてお試しください。';

  function isFixturePage() {
    return !!(document.body && document.body.hasAttribute('data-fixture-page'));
  }
  // Explicit server decisions may be retried. A 422 or a 5xx cannot prove the
  // write was rejected, so they stay locked. Everything else is unknown. No raw
  // server string is ever rendered.
  function classifyBuyStatus(status) {
    var value = Number(status);
    if (!isFinite(value)) return 'unknown';
    if (value === 422) return 'partial';
    if (value === 429) return 'throttle';
    if (value >= 500) return 'uncertain';
    if (value >= 400 && value < 500) return 'rejected';
    return 'unknown';
  }
  function buyOutcomeMessage(kind) {
    if (kind === 'partial') return BUY_PARTIAL_MESSAGE;
    if (kind === 'uncertain') return BUY_SERVER_MESSAGE;
    if (kind === 'throttle') return BUY_THROTTLE_MESSAGE;
    if (kind === 'rejected') return BUY_REJECTED_MESSAGE;
    return BUY_UNKNOWN_MESSAGE;
  }
  function buyStatusRecoverable(kind) {
    return kind === 'throttle' || kind === 'rejected';
  }
  // The request body is an items array, so a real success body is
  // { items: [ { id|variant_id, quantity, ... } ] }. Anything else is unknown:
  // a bare line object, null, {}, an empty list, a wrong variant, a fractional
  // quantity or a quantity below the request must never reach checkout.
  function validatedAddResult(result, item) {
    if (!result || typeof result !== 'object') return false;
    var items = result.items;
    if (!Array.isArray(items) || items.length === 0) return false;
    var wanted = String(item.id);
    var enough = false;
    for (var i = 0; i < items.length; i += 1) {
      var line = items[i];
      if (!line || typeof line !== 'object') return false;
      var ids = [line.variant_id, line.id];
      var matched = false;
      for (var j = 0; j < ids.length; j += 1) {
        if (ids[j] !== null && ids[j] !== undefined && String(ids[j]) === wanted) { matched = true; break; }
      }
      if (!matched) return false;
      var quantity = line.quantity;
      if (typeof quantity !== 'number' || !isFinite(quantity)) return false;
      if (Math.floor(quantity) !== quantity || quantity <= 0) return false;
      if (quantity >= item.quantity) enough = true;
    }
    return enough;
  }

  function attrQuantity(el, prop, fallback) {
    if (!el || !el.dataset) return fallback;
    var raw = el.dataset[prop];
    if (raw === undefined || raw === null || raw === '') return fallback;
    var value = Number(raw);
    return isFinite(value) ? value : fallback;
  }
  // `show_quantity=true` renders the stepper `#quantity`; `show_quantity=false`
  // renders a hidden `input[name="quantity"]`. Resolve either one strictly
  // inside this form, so the hidden field obeys the selected variant's real rule
  // and stays in sync when the variant changes.
  function quantityField(form) {
    if (!form) return null;
    return $('#quantity', form) || $('input[name="quantity"]', form);
  }
  // The selected variant's real quantity_rule wins; otherwise the server-set
  // data attributes, then the documented default (min 1, no max, increment 1).
  // A missing/empty max is unlimited; invalid values are never coerced.
  function quantityRule(form) {
    var select = $('#variant', form);
    var option = select && select.options ? select.options[select.selectedIndex] : null;
    var source = option && option.dataset && option.dataset.quantityMin !== undefined ? option : quantityField(form);
    var min = Math.max(1, Math.floor(attrQuantity(source, 'quantityMin', BUY_DEFAULT_MIN)));
    var max = attrQuantity(source, 'quantityMax', null);
    if (max !== null) max = Math.floor(max) < min ? null : Math.floor(max);
    var increment = Math.max(1, Math.floor(attrQuantity(source, 'quantityIncrement', BUY_DEFAULT_INCREMENT)));
    return { min: min, max: max, increment: increment };
  }
  function parseQuantity(raw, rule) {
    var text = raw === null || raw === undefined ? '' : String(raw).trim();
    if (!/^[0-9]+$/.test(text)) return null;
    var value = Number(text);
    if (!isFinite(value) || value <= 0 || value > Number.MAX_SAFE_INTEGER) return null;
    if (value < rule.min || (rule.max !== null && value > rule.max)) return null;
    if ((value - rule.min) % rule.increment !== 0) return null;
    return value;
  }
  function updateQuantityValidity(form) {
    var input = quantityField(form);
    if (!input || input.type === 'hidden' || typeof input.setCustomValidity !== 'function') return;
    var rule = quantityRule(form);
    input.setCustomValidity(parseQuantity(input.value, rule) === null ? cartQuantityMessage(rule) : '');
  }
  function applyQuantityRule(form) {
    var input = quantityField(form);
    if (!input) return;
    var rule = quantityRule(form);
    if (input.type === 'hidden') {
      // A positive stepper value that is off the selected variant's rule is
      // normalised to that rule's min, so switching variants keeps the hidden
      // quantity valid. 0/empty/negative/fractional stays untouched so the buy
      // path rejects it instead of inventing a quantity.
      var raw = String(input.value).trim();
      if (parseQuantity(raw, rule) === null && /^[0-9]+$/.test(raw) && Number(raw) > 0) {
        input.value = String(rule.min);
      }
      return;
    }
    input.min = String(rule.min);
    if (rule.max === null) input.removeAttribute('max'); else input.max = rule.max;
    input.step = String(rule.increment);
    if (parseQuantity(input.value, rule) === null) input.value = String(rule.min);
    updateQuantityValidity(form);
  }

  function readBuyError(form) {
    return form ? $('[data-buy-error]', form) : null;
  }
  function clearBuyError(form) {
    var message = readBuyError(form);
    if (message) { message.textContent = ''; message.hidden = true; }
    var link = form ? $('[data-buy-error-cart]', form) : null;
    if (link) link.hidden = true;
  }
  function showBuyError(form, text, showCartLink) {
    var message = readBuyError(form);
    if (message) { message.textContent = text; message.hidden = false; }
    var link = form ? $('[data-buy-error-cart]', form) : null;
    if (link) link.hidden = !showCartLink;
  }

  function currentVariantAvailable(form) {
    var select = $('#variant', form);
    var option = select && select.options ? select.options[select.selectedIndex] : null;
    if (option) return option.dataset.available === 'true' && !option.disabled;
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput || !idInput.dataset) return true;
    return idInput.dataset.available !== 'false';
  }

  /* ── variant URL state (local, no extra framework) ─────────────────────── */
  // A user selection updates only the `variant` parameter through replaceState,
  // so every other query parameter, the hash and history.state survive and no
  // meaningless history entry is added. A normal first load never writes.
  function urlConstructor() {
    if (typeof window !== 'undefined' && window.URL) return window.URL;
    if (typeof URL === 'function') return URL;
    return null;
  }
  function currentUrl() {
    var Ctor = urlConstructor();
    if (!Ctor || typeof window === 'undefined' || !window.location) return null;
    try { return new Ctor(window.location.href, 'https://shop.invalid/'); } catch (error) { return null; }
  }
  function variantParamFromUrl() {
    var url = currentUrl();
    return url && url.searchParams ? url.searchParams.get('variant') : null;
  }
  function variantUrlWith(id) {
    var url = currentUrl();
    if (!url || !url.searchParams) return null;
    try {
      url.searchParams.set('variant', String(id));
      return url.pathname + url.search + url.hash;
    } catch (error) { return null; }
  }
  function replaceVariantUrl(id) {
    var next = variantUrlWith(id);
    if (!next) return false;
    var history = typeof window !== 'undefined' ? window.history : null;
    if (!history || typeof history.replaceState !== 'function') return false;
    try {
      history.replaceState(history.state === undefined ? null : history.state, '', next);
      return true;
    } catch (error) { return false; }
  }
  function selectedOption(select) {
    return select && select.options ? select.options[select.selectedIndex] : null;
  }
  function selectIndexById(select, id) {
    if (!select || !select.options || id === null || id === undefined || id === '') return -1;
    for (var i = 0; i < select.options.length; i += 1) {
      if (String(select.options[i].value) === String(id)) return i;
    }
    return -1;
  }
  // The real first available option of THIS product. It must not be the
  // deep-linked serverIndex: on a history return to a plain URL the form has to
  // show the same variant a fresh load would (selected_or_first_available).
  function defaultSelectIndex(select) {
    if (!select || !select.options || !select.options.length) return 0;
    for (var i = 0; i < select.options.length; i += 1) {
      var option = select.options[i];
      if (option.disabled) continue;
      if (option.dataset && option.dataset.available === 'false') continue;
      return i;
    }
    return 0;
  }
  // A locked request captured the variant it is buying. Every sync/bind/history/
  // reload entry restores that captured option first, so display, media and URL
  // can never drift away from the purchase id. It covers the native, Ajax and
  // unknown-result locks because it only reads the shared busy flag.
  function restoreCapturedVariant(form) {
    if (!form || !form.__bblabBusy) return;
    var select = $('#variant', form);
    if (!select || !select.options) return;
    var index = form.__bblabSelectIndex;
    if (typeof index !== 'number' || index < 0 || index >= select.options.length) return;
    if (select.selectedIndex !== index) select.selectedIndex = index;
  }
  function currentPathname() {
    var url = currentUrl();
    return url ? url.pathname : null;
  }
  // History is only ours while the document still points at the same product
  // path. A navigation to another pathname is a different page and must not be
  // hijacked or rewritten.
  function sameProductPath(form) {
    if (!form || !form.__bblabPathname) return true;
    var now = currentPathname();
    if (now === null) return true;
    return now === form.__bblabPathname;
  }
  // Re-apply the URL's variant on the same product path:
  //  - a plain URL (no `variant`) restores the real first available variant and
  //    leaves that URL unpolluted;
  //  - an unknown / foreign id falls back to the real default and corrects the
  //    URL so it stops contradicting the form;
  //  - while a request is busy the captured variant wins; if an external script
  //    changed only the URL variant it is restored, preserving everything else;
  //  - a different pathname is another page and is left alone.
  function syncProductFromUrl() {
    var form = $('#product-form', document);
    if (!form) return;
    var select = $('#variant', form);
    if (!select) return;
    if (!sameProductPath(form)) return;
    var scope = form.__bblabRoot || document;
    var id = variantParamFromUrl();
    restoreCapturedVariant(form);
    if (form.__bblabBusy) {
      // The captured purchase id owns the URL while the request is locked. A
      // plain same-path URL must gain a captured non-default id, so sharing or
      // refreshing keeps the same spec; a captured default stays plain and any
      // mismatching variant is corrected. replaceVariantUrl preserves the other
      // query parameters, the hash and history.state.
      var captured = selectedOption(select);
      if (captured) {
        if (id === null || id === '') {
          if (select.selectedIndex !== defaultSelectIndex(select)) replaceVariantUrl(captured.value);
        } else if (String(id) !== String(captured.value)) {
          replaceVariantUrl(captured.value);
        }
      }
      var lockedOption = syncProductForm(form, scope);
      syncGalleryMedia(scope, lockedOption);
      return;
    }
    if (id === null || id === '') {
      select.selectedIndex = defaultSelectIndex(select);
    } else {
      var index = selectIndexById(select, id);
      if (index === -1) {
        select.selectedIndex = defaultSelectIndex(select);
        var fallback = selectedOption(select);
        if (fallback) replaceVariantUrl(fallback.value);
      } else {
        select.selectedIndex = index;
      }
    }
    clearBuyError(form);
    var option = syncProductForm(form, scope);
    syncGalleryMedia(scope, option);
  }
  var variantHistoryBound = false;
  function initVariantHistory() {
    if (variantHistoryBound) return;
    if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') return;
    variantHistoryBound = true;
    window.addEventListener('popstate', function () { syncProductFromUrl(); });
  }
  // A section reload or a bfcache restore re-reads the live controls once, so
  // price/SKU/quantity and an explicit media binding stay consistent.
  function resyncProductForms(root) {
    $$('#product-form', root || document).forEach(function (form) {
      var scope = form.__bblabRoot || root || document;
      var option = syncProductForm(form, scope);
      // syncProductForm restored the captured variant first, so the media must
      // follow that captured option even while a request is locked. A section
      // reload can never move the gallery away from the purchase id.
      syncGalleryMedia(scope, option);
    });
  }

  function syncProductForm(form, root) {
    if (!form) return null;
    // Display and media are driven by the captured purchase id while busy, no
    // matter what another script wrote straight into the select.
    restoreCapturedVariant(form);
    var select = $('#variant', form);
    var option = select && select.options ? select.options[select.selectedIndex] : null;
    var scope = root || document;
    var priceNode = $('#detail-price', scope);
    if (option && priceNode && option.dataset.price) priceNode.textContent = option.dataset.price;
    // SKU follows the selected option; for a single variant it comes from the
    // hidden id field. The node may have started empty and hides when blank.
    var sku = '';
    if (option) sku = option.dataset.sku || '';
    else if (form) {
      var idInput = form.querySelector('input[name="id"]');
      if (idInput && idInput.dataset) sku = idInput.dataset.sku || '';
    }
    var skuNode = $('[data-buy-sku]', scope);
    if (skuNode) { skuNode.textContent = String(sku); skuNode.hidden = String(sku) === ''; }
    var available = currentVariantAvailable(form);
    var busy = !!form.__bblabBusy;
    var submit = $('button[type="submit"]', form);
    var buyNow = $('[data-action="buy-now"]', form);
    // A section reload or page restore must never reopen a locked form.
    if (submit && !busy) submit.disabled = !available;
    if (buyNow && !busy) buyNow.disabled = !available;
    var stock = $('[data-stock-status]', scope);
    if (stock) stock.hidden = available;
    if (!busy) applyQuantityRule(form);
    return option;
  }

  function formItem(form) {
    var data = new FormData(form);
    var id = data.get('id');
    var rule = quantityRule(form);
    var quantity = parseQuantity(data.get('quantity'), rule);
    if (quantity === null) return { error: cartQuantityMessage(rule) };
    if (!id) return { item: null };
    var item = { id: id, quantity: quantity };
    var sellingPlan = data.get('selling_plan');
    if (sellingPlan) item.selling_plan = sellingPlan;
    var properties = {};
    if (typeof data.forEach === 'function') {
      data.forEach(function (value, key) {
        var match = /^properties\[(.+)\]$/.exec(String(key));
        if (match) properties[match[1]] = value;
      });
    }
    if (Object.keys(properties).length) item.properties = properties;
    return { item: item };
  }

  // Controls that would change a request body. Both buy buttons and the two
  // quantity steppers are unnamed, so disabling them keeps every serialised
  // field. The named quantity input and variant select are never disabled.
  function buyLockParts(form) {
    return {
      buttons: [$('button[type="submit"]', form), $('[data-action="buy-now"]', form)]
        .concat($$('[data-qty-step]', form)).filter(Boolean),
      quantity: quantityField(form),
      select: $('#variant', form),
    };
  }
  function captureBuyState(form) {
    var parts = buyLockParts(form);
    return parts.buttons.concat([parts.quantity, parts.select]).filter(Boolean).map(function (el) {
      return { el: el, disabled: !!el.disabled, readOnly: 'readOnly' in el ? !!el.readOnly : false };
    });
  }
  function restoreBuyState(form) {
    (form.__bblabPrev || []).forEach(function (entry) {
      entry.el.disabled = entry.disabled;
      if ('readOnly' in entry.el) entry.el.readOnly = entry.readOnly;
    });
    form.__bblabPrev = null;
  }
  // Native add stays serialisable: only unnamed controls are disabled and the
  // quantity input becomes read-only, so `id`/`quantity`/`properties`/
  // `selling_plan` still reach the browser's first FormData.
  function applyBuyLock(form) {
    if (!form) return;
    var parts = buyLockParts(form);
    parts.buttons.forEach(function (el) { el.disabled = true; });
    if (form.__bblabNative) {
      if (parts.quantity && parts.quantity.type !== 'hidden' && 'readOnly' in parts.quantity) {
        parts.quantity.readOnly = true;
      }
    } else {
      if (parts.quantity) parts.quantity.disabled = true;
      if (parts.select) parts.select.disabled = true;
    }
    form.setAttribute('aria-busy', 'true');
  }
  function holdBuyLock(form, nativeMode, root) {
    if (!form || form.__bblabBusy) return;
    var select = $('#variant', form);
    form.__bblabBusy = true;
    form.__bblabNative = !!nativeMode;
    form.__bblabNativeLeft = false;
    form.__bblabRoot = root || form.__bblabRoot || document;
    form.__bblabSelectIndex = select && typeof select.selectedIndex === 'number' ? select.selectedIndex : null;
    form.__bblabPrev = captureBuyState(form);
    applyBuyLock(form);
  }
  // One request owns both buttons and the controls that would change its body.
  // Previous states are recorded so an explicit rejection restores exactly what
  // the markup had, then availability decides the buy buttons.
  function setBuyBusy(form, busy, root) {
    if (!form) return;
    if (busy) holdBuyLock(form, false, root);
    else releaseBuyBusy(form);
  }
  function releaseBuyBusy(form) {
    if (!form) return;
    form.__bblabBusy = false;
    form.__bblabNative = false;
    form.__bblabUnknown = false;
    form.__bblabNativeLeft = false;
    form.__bblabSelectIndex = null;
    restoreBuyState(form);
    form.removeAttribute('aria-busy');
    syncProductForm(form, form.__bblabRoot);
  }
  // A partial or unknown answer keeps the lock, but that lock must survive
  // section reloads and page restores; only an explicit retryable rejection or
  // a cancelled native submit clears it.
  function holdUnknownBuyResult(form) {
    if (!form) return;
    form.__bblabUnknown = true;
    holdBuyLock(form, false, form.__bblabRoot);
    applyBuyLock(form);
  }
  function applyBuyHttpFailure(form, kind) {
    if (buyStatusRecoverable(kind)) {
      releaseBuyBusy(form);
      showBuyError(form, buyOutcomeMessage(kind), false);
      return;
    }
    holdUnknownBuyResult(form);
    showBuyError(form, buyOutcomeMessage(kind), true);
  }

  function submitBuyNow(form, item, root) {
    if (isFixturePage()) {
      // Offline fixture: never send the Ajax add or hand off to a real
      // /checkout. Show the local simulation state instead.
      toast('ローカルfixtureのため、実際の購入には進みません。');
      return;
    }
    setBuyBusy(form, true, root);
    clearBuyError(form);
    var controller = typeof window.AbortController === 'function' ? new window.AbortController() : null;
    var options = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [item] }),
    };
    if (controller) options.signal = controller.signal;

    // The deadline is independent of fetch, so a missing AbortController or a
    // response body that never resolves still ends the attempt. `settled` makes
    // the first outcome final: a late reply can never reach checkout.
    var settled = false;
    var timeoutId = null;
    var deadline = new Promise(function (resolve) {
      if (!window.setTimeout) return;
      timeoutId = window.setTimeout(function () { resolve({ timedOut: true }); }, BUY_TIMEOUT_MS);
    });
    function finish(handler) {
      if (settled) return;
      settled = true;
      if (timeoutId) { window.clearTimeout(timeoutId); timeoutId = null; }
      handler();
    }

    var request = fetch(cartAddPath(), options)
      .then(function (response) {
        if (!response.ok) {
          var httpError = new Error('http');
          httpError.kind = 'http';
          httpError.status = response.status;
          throw httpError;
        }
        if (typeof response.json !== 'function') {
          var parseError = new Error('parse');
          parseError.kind = 'unknown';
          throw parseError;
        }
        return response.json();
      })
      .then(function (result) {
        if (result && typeof result === 'object' && result.status !== undefined && result.status !== null) {
          var platformError = new Error('platform');
          platformError.kind = 'http';
          platformError.status = typeof result.status === 'number' ? result.status : 0;
          throw platformError;
        }
        return { result: result };
      })
      .catch(function (error) {
        return { error: error };
      });

    Promise.race([request, deadline]).then(function (outcome) {
      if (!outcome || outcome.timedOut) {
        if (controller) { try { controller.abort(); } catch (abortError) { /* already gone */ } }
        finish(function () {
          holdUnknownBuyResult(form);
          showBuyError(form, BUY_UNKNOWN_MESSAGE, true);
        });
        return;
      }
      if (outcome.error) {
        var error = outcome.error;
        if (error && error.kind === 'http') {
          finish(function () { applyBuyHttpFailure(form, classifyBuyStatus(error.status)); });
          return;
        }
        // Any fetch rejection, including a plain Error, is an unknown outcome.
        finish(function () {
          holdUnknownBuyResult(form);
          showBuyError(form, BUY_UNKNOWN_MESSAGE, true);
        });
        return;
      }
      if (!validatedAddResult(outcome.result, item)) {
        finish(function () {
          holdUnknownBuyResult(form);
          showBuyError(form, BUY_UNKNOWN_MESSAGE, true);
        });
        return;
      }
      finish(function () {
        clearBuyError(form);
        // Keep the lock until the browser leaves the page so a late second
        // click cannot add the item again.
        window.location.href = checkoutPath();
      });
    }).catch(function () {
      if (settled) return;
      finish(function () {
        holdUnknownBuyResult(form);
        showBuyError(form, BUY_UNKNOWN_MESSAGE, true);
      });
    });
  }

  function bindProduct(root) {
    bindGallery(root);
    var scope = root || document;
    var form = $('#product-form', scope);
    var select = $('#variant', scope);
    var quantity = form ? quantityField(form) : ($('#quantity', scope) || $('input[name="quantity"]', scope));
    var buyNow = $('[data-action="buy-now"]', scope);
    // Remember the product pathname this form belongs to. A history navigation
    // to another page is not ours to rewrite.
    if (form && !form.__bblabPathname) form.__bblabPathname = currentPathname();
    if (select && select.dataset.bound !== 'true') {
      select.dataset.bound = 'true';
      // A locked request owns the selected variant; a rebind or a deep link must
      // never move it away from the captured purchase id.
      restoreCapturedVariant(form);
      var urlVariant = variantParamFromUrl();
      if (!(form && form.__bblabBusy) && urlVariant !== null && urlVariant !== '') {
        var urlIndex = selectIndexById(select, urlVariant);
        if (urlIndex !== -1) {
          select.selectedIndex = urlIndex;
        } else {
          // An unknown/foreign deep link falls back to the real first available
          // variant of this product, never to the deep-linked serverIndex.
          select.selectedIndex = defaultSelectIndex(select);
          var fallbackOption = selectedOption(select);
          if (fallbackOption) replaceVariantUrl(fallbackOption.value);
        }
      }
      select.addEventListener('change', function () {
        if (form && form.__bblabBusy) {
          // A locked request already captured the variant id; any source of a
          // change restores it before URL/media/price/SKU can move.
          restoreCapturedVariant(form);
          return;
        }
        clearBuyError(form);
        var option = syncProductForm(form, scope);
        if (option && variantParamFromUrl() !== String(option.value)) replaceVariantUrl(option.value);
        syncGalleryMedia(scope, option);
      });
    }
    // A single-variant page has no select to contradict, but a foreign
    // `?variant=` would still leave the URL disagreeing with the posted id.
    if (!select && form && form.dataset.variantUrlBound !== 'true') {
      form.dataset.variantUrlBound = 'true';
      var hiddenId = form.querySelector('input[name="id"]');
      var singleVariant = variantParamFromUrl();
      if (!form.__bblabBusy && hiddenId && singleVariant !== null && singleVariant !== '' && String(singleVariant) !== String(hiddenId.value)) {
        replaceVariantUrl(hiddenId.value);
      }
    }
    if (quantity && quantity.dataset.bound !== 'true') {
      quantity.dataset.bound = 'true';
      quantity.addEventListener('input', function () {
        // An unknown-result message is persistent; typing through it must not
        // clear the warning or the lock.
        if (form && form.__bblabBusy) return;
        clearBuyError(form);
        updateQuantityValidity(form);
      });
    }
    $$('[data-qty-step]', scope).forEach(function (button) {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';
      button.addEventListener('click', function () {
        if (form && form.__bblabBusy) return;
        var input = quantityField(form || scope);
        if (!input) return;
        var rule = quantityRule(form || input);
        var raw = Number(input.value);
        var base = isFinite(raw) && raw >= rule.min ? raw : rule.min - rule.increment;
        var direction = Number(button.dataset.qtyStep) || 0;
        var next = base + direction * rule.increment;
        next = rule.min + Math.round((next - rule.min) / rule.increment) * rule.increment;
        if (rule.max !== null) next = Math.min(rule.max, next);
        input.value = String(Math.max(rule.min, next));
        clearBuyError(form);
        updateQuantityValidity(form);
      });
    });
    if (form && form.dataset.submitBound !== 'true') {
      form.dataset.submitBound = 'true';
      // Native add stays a real POST: validate availability and id first, then
      // share the lock without disabling the named controls, so the browser's
      // first FormData keeps id/quantity/properties/selling_plan.
      form.addEventListener('submit', function (event) {
        if (isFixturePage()) {
          if (!event.defaultPrevented) {
            event.preventDefault();
            toast('ローカルfixtureです。実際の送信・購入は行われません。');
          }
          return;
        }
        if (form.__bblabBusy) { event.preventDefault(); return; }
        if (!currentVariantAvailable(form)) {
          event.preventDefault();
          showBuyError(form, BUY_SOLD_OUT_MESSAGE, false);
          return;
        }
        var parsed = formItem(form);
        if (parsed.error) {
          event.preventDefault();
          showBuyError(form, parsed.error, false);
          return;
        }
        if (!parsed.item) {
          event.preventDefault();
          showBuyError(form, BUY_MISSING_ID_MESSAGE, false);
          return;
        }
        clearBuyError(form);
        holdBuyLock(form, true, scope);
        var token = (form.__bblabNativeToken || 0) + 1;
        form.__bblabNativeToken = token;
        // If a listener registered after this one cancels the POST, nothing left
        // the page, so the cancellation must release the lock. A browser may run
        // a microtask checkpoint after every listener (Chrome does this for
        // natively dispatched events), so a microtask queued here can run before
        // that later listener calls preventDefault and therefore never observe
        // the cancel. The zero-delay task below is authoritative: it runs only
        // after the whole submit dispatch has returned, so `defaultPrevented`
        // is final by then. A POST that proceeds keeps the lock until navigation
        // or a bfcache restore.
        function confirmNativeCancelled() {
          if (form.__bblabNativeToken !== token || !form.__bblabBusy || !form.__bblabNative) return;
          if (event.defaultPrevented) releaseBuyBusy(form);
        }
        Promise.resolve().then(confirmNativeCancelled);
        if (typeof window.setTimeout === 'function') {
          window.setTimeout(confirmNativeCancelled, 0);
        }
      });
    }
    if (buyNow && buyNow.dataset.bound !== 'true') {
      buyNow.dataset.bound = 'true';
      buyNow.addEventListener('click', function () {
        if (!form || form.__bblabBusy || !currentVariantAvailable(form)) return;
        var parsed = formItem(form);
        if (parsed.error) { showBuyError(form, parsed.error, false); return; }
        if (!parsed.item) { showBuyError(form, BUY_MISSING_ID_MESSAGE, false); return; }
        submitBuyNow(form, parsed.item, scope);
      });
    }
    if (form) {
      var currentOption = syncProductForm(form, scope);
      syncGalleryMedia(scope, currentOption);
    }
  }

  /* ── card hover image: warm the clipped second image near the viewport ─── */
  // `.product-media .alternate` is clipped shut (`clip-path: inset(0 100% 0 0)`)
  // until hover, so Chrome's lazy loader never counts it as visible and leaves it
  // at naturalWidth 0; the first hover then reveals a late-pop during the wipe.
  // On hover-capable pointers only, when a card's media nears the viewport, switch
  // that one alternate image to eager loading. Native lazy loading stays in charge
  // of the first image and of touch/no-hover devices, and nothing else changes.
  var HOVER_QUERY = '(hover: hover)';
  var cardHoverObserver = null;
  function cardHoverObserverEl() {
    if (cardHoverObserver) return cardHoverObserver;
    cardHoverObserver = new window.IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var alternate = entry.target.querySelector('img.alternate');
        if (alternate) alternate.loading = 'eager';
        cardHoverObserver.unobserve(entry.target);
      });
    }, { rootMargin: '200px' });
    return cardHoverObserver;
  }
  function initCardHoverImages(root) {
    if (!window.matchMedia || !window.matchMedia(HOVER_QUERY).matches) return;
    if (!window.IntersectionObserver) return;
    var observer = cardHoverObserverEl();
    $$('.product-media', root || document).forEach(function (media) {
      if (media.dataset.hoverObserved === 'true') return;
      if (!$('img.alternate', media)) return;
      media.dataset.hoverObserved = 'true';
      observer.observe(media);
    });
  }

  // A bfcache restore can bring the DOM back while a native POST or an unknown
  // Ajax result is still unresolved. Only a native POST actually hands the
  // document to the next page, so `pagehide` records that hand-off. A persisted
  // `pageshow` after that hand-off is the customer coming back, and the form is
  // unlocked exactly then. An Ajax lock never leaves the page, so it stays
  // locked through both events, and a synthetic pageshow or a form that never
  // left keeps its lock too. Nothing here clears the persistent message: only an
  // explicit rejection or a cancelled submit does.
  function markNativeBuyLeft() {
    $$('#product-form', document).forEach(function (form) {
      if (form.__bblabBusy && form.__bblabNative && !form.__bblabUnknown) {
        form.__bblabNativeLeft = true;
      }
    });
  }
  function restoreBuyLocks(root, persisted) {
    $$('#product-form', root || document).forEach(function (form) {
      if (!form.__bblabBusy) return;
      if (persisted && form.__bblabNativeLeft && !form.__bblabUnknown) {
        // The native POST left this document and the browser cached it; the
        // customer is back, so restore the original controls and let them buy.
        releaseBuyBusy(form);
        return;
      }
      applyBuyLock(form);
    });
  }
  function initBfcacheGuard() {
    if (typeof window.addEventListener !== 'function') return;
    window.addEventListener('pagehide', function () { markNativeBuyLeft(); markNativeCartLeft(); });
    window.addEventListener('pageshow', function (event) {
      restoreBuyLocks(document, !!(event && event.persisted));
      restoreCartLocks(document, !!(event && event.persisted));
      resyncProductForms(document);
    });
  }

  function init() {
    initHeader();
    initSearch();
    initSaved(document);
    bindProduct(document);
    initRails(document);
    initCollectionNotice(document);
    initCardHoverImages(document);
    initCart(document);
    initBfcacheGuard();
    initVariantHistory();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) {
    initSaved(event.target);
    bindProduct(event.target);
    initHeader();
    initSearch();
    initRails(event.target);
    initCollectionNotice(event.target);
    initCardHoverImages(event.target);
    initCart(event.target);
    restoreBuyLocks(event.target);
    restoreCartLocks(event.target);
    resyncProductForms(event.target);
    // Re-query then drop any menu/drawer state the replaced markup left behind.
    resetHeaderState();
  });
  // Native recommendations replace the fallback host with server-rendered cards
  // after the swap. initSaved only sees the buttons present at init time, so
  // re-sync the freshly inserted cards against the same local store. Matching is
  // a plain data-attribute comparison (never an interpolated selector); a
  // missing or non-matching identity is ignored. The event may be re-dispatched
  // and this handler only re-reads state, so it is idempotent and rebinds
  // nothing on the purchase form, navigation or the global click delegation.
  document.addEventListener('bblab:recommendations:loaded', function (event) {
    var detail = event && event.detail;
    var productId = detail && detail.productId;
    var sectionId = detail && detail.sectionId;
    if (!productId || !sectionId) return;
    $$('[data-bblab-recommendations-host]').forEach(function (host) {
      if (host.getAttribute('data-recommendations-product-id') !== String(productId)) return;
      if (host.getAttribute('data-recommendations-section-id') !== String(sectionId)) return;
      initSaved(host);
    });
  });
})();
